import * as React from 'react';
import { i18n } from '../../../i18n/i18n';
import { fn0 } from '../../../core/formatter/formatNumber';

export function renderFaktorQuelle(value: string, einheit: string, quelle: string, quellen: string[], faktor_map?: any, xtra_quellen_row?: boolean) {
    // Anpassung der Einheit
    einheit = einheit.replace('Liter' , 'l');

    if (faktor_map) {
        const keys = Object.keys(faktor_map);
        let str_fakt = '#quellen#';
        if (xtra_quellen_row) {
            str_fakt += ' ' + '__' + ' ' + '__' + ' ' + '__' + ' '  + '__' + ' ' + '#';
        }
        keys.forEach((k: string) => {
            const item = faktor_map[k];
            const quelle_fakt = item.quelle;
            const einheit_fakt = item.einheit;
            const value_fakt = fn0(item.wert);
            let quelle_fakt_res = '';
            if (quelle_fakt) {
                quelle_fakt_res = getUniqueQuelle(quelle_fakt, quellen);
            }

            str_fakt += value_fakt + '__' + einheit_fakt + '__' + quelle_fakt_res + '__' + (quelle_fakt || i18n('Nicht verfügbar', 'sys')) + '__' + k + '#';
        });
        // console.log('Quellen', xtra_quellen_row, str_fakt);
        return str_fakt;
    }

    let quelle_res = ' ';
    if (quelle) {
        quelle_res = getUniqueQuelle(quelle, quellen);
    }

    const str =  '#quelle#' + value + '#' + einheit + '#' + quelle_res + '#' + (quelle || i18n('Nicht verfügbar', 'sys'));
    if (faktor_map) {
        console.log('FaktorQuelle', str, faktor_map);
    }
    return str;
}
function getUniqueQuelle(quelle: string, quellen: string[]) {
    const idx = quellen.indexOf(quelle);
    let quelle_res = ' ';
    if (idx >= 0 ) {
        quelle_res = (idx + 1) + '';
    } else {
        quellen.push(quelle);
        quelle_res = (quellen.indexOf(quelle) + 1) + '';
    }
    return quelle_res;
}
